import { AddressForValidationSchema } from '@app/models/wms';

export const getWarehouseAddress = (address: AddressForValidationSchema): AddressForValidationSchema => ({
  provider: address.provider,
  provider_address_uid: address.provider_address_uid,
  street_name: address.street_name,
  street_number: address.street_number || null,
  place_name: address.place_name || null,
});
